import { compose } from 'recompose'
import toReduxFormField from '../../../enhancers/ToReduxFormField'

const enhance = compose(toReduxFormField('InputText'))

export default enhance
